import * as Sentry from '@sentry/react'

export type ReleaseEvent = {
  type:
    | 'step_update'
    | 'release_status'
    | 'diagnosis_stream'
    | 'diagnosis_done'
    | 'ping'
    | 'error'
  release_id?: number
  repo?: string
  step?: string
  status?: string
  detail?: string
  error?: string
  content?: string
  diagnosis?: string
  suggested_prompt?: string
}

export function createReleaseSocket(
  onEvent: (event: ReleaseEvent) => void,
  onClose?: () => void,
) {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const ws = new WebSocket(`${protocol}//${window.location.host}/api/release/ws`)

  ws.onmessage = (e) => {
    try {
      const event: ReleaseEvent = JSON.parse(e.data)
      if (event.type === 'ping') return
      if (event.type === 'error') {
        Sentry.captureMessage(`Release error: ${event.detail ?? 'Unknown'}`, 'error')
      }
      onEvent(event)
    } catch {
      console.error('Failed to parse release event:', e.data)
    }
  }

  ws.onclose = () => onClose?.()

  const close = () => ws.close()

  return { close, ws }
}
